export const emptyMapping = {
    unproductiveResourceIds: [],
    resourceMappings: [],
    distributions: [],
    excludedSubtaskTemplateIds: [],
};
const getResourceMapping = (mapping, resourceId) => {
    var _a;
    return (_a = mapping.resourceMappings.find(m => m.resourceId === resourceId)) !== null && _a !== void 0 ? _a : {
        resourceId,
        targets: [],
        excludedTemplateIds: [],
    };
};
const setResourceMapping = (mapping, resourceMapping) => (Object.assign(Object.assign({}, mapping), { resourceMappings: [
        ...mapping.resourceMappings.filter(m => m.resourceId !== resourceMapping.resourceId),
        ...(resourceMapping.targets.length > 0 || resourceMapping.excludedTemplateIds.length > 0
            ? [resourceMapping]
            : []),
    ] }));
export const getTargets = (mapping, resourceId) => getResourceMapping(mapping, resourceId).targets;
export const setTargets = (mapping, resourceId, targets) => setResourceMapping(mapping, Object.assign(Object.assign({}, getResourceMapping(mapping, resourceId)), { targets }));
// With percentages every row has one; without, the time is split by how often each task occurs.
export const isPercentageMode = (targets) => targets.some(t => t.percentage != null);
export const getPercentageTotal = (targets) => targets.reduce((sum, t) => sum + (t.percentage || 0), 0);
export const hasCompletePercentages = (targets) => !isPercentageMode(targets) || getPercentageTotal(targets) === 100;
export const getExcludedTemplateIds = (mapping, resourceId) => getResourceMapping(mapping, resourceId).excludedTemplateIds;
export const setTemplateExcluded = (mapping, resourceId, taskTemplateId, isExcluded) => {
    const resourceMapping = getResourceMapping(mapping, resourceId);
    const others = resourceMapping.excludedTemplateIds.filter(id => id !== taskTemplateId);
    return setResourceMapping(mapping, Object.assign(Object.assign({}, resourceMapping), { excludedTemplateIds: isExcluded ? [...others, taskTemplateId] : others }));
};
export const isAdjusted = (mapping, resourceId) => mapping.unproductiveResourceIds.includes(resourceId) ||
    mapping.resourceMappings.some(m => m.resourceId === resourceId);
// Back to the automatic mapping only: no manual mapping, no switched-off templates, not unproductive.
export const resetItem = (mapping, resourceId) => (Object.assign(Object.assign({}, mapping), { unproductiveResourceIds: mapping.unproductiveResourceIds.filter(id => id !== resourceId), resourceMappings: mapping.resourceMappings.filter(m => m.resourceId !== resourceId) }));
export const setSubtaskExcluded = (mapping, subTaskTemplateId, isExcluded) => {
    const others = mapping.excludedSubtaskTemplateIds.filter(id => id !== subTaskTemplateId);
    return Object.assign(Object.assign({}, mapping), { excludedSubtaskTemplateIds: isExcluded ? [...others, subTaskTemplateId] : others, 
        // An excluded subtask keeps its value, so it no longer takes part in a distribution.
        distributions: isExcluded
            ? mapping.distributions
                .map(d => (Object.assign(Object.assign({}, d), { shares: d.shares.filter(s => s.subTaskTemplateId !== subTaskTemplateId) })))
                .filter(d => d.shares.length > 0)
            : mapping.distributions });
};
export const setUnproductive = (mapping, resourceId, isUnproductive) => (Object.assign(Object.assign({}, mapping), { unproductiveResourceIds: isUnproductive
        ? [...mapping.unproductiveResourceIds.filter(id => id !== resourceId), resourceId]
        : mapping.unproductiveResourceIds.filter(id => id !== resourceId) }));
export const getShares = (mapping, mainTaskTemplateId) => { var _a, _b; return (_b = (_a = mapping.distributions.find(d => d.mainTaskTemplateId === mainTaskTemplateId)) === null || _a === void 0 ? void 0 : _a.shares) !== null && _b !== void 0 ? _b : []; };
export const setShares = (mapping, mainTaskTemplateId, shares) => (Object.assign(Object.assign({}, mapping), { distributions: [
        ...mapping.distributions.filter(d => d.mainTaskTemplateId !== mainTaskTemplateId),
        ...(shares.length > 0 ? [{ mainTaskTemplateId, shares }] : []),
    ] }));
export const isTemplateAdjusted = (mapping, template) => getShares(mapping, template.taskTemplateId).length > 0 ||
    template.subtasks.some(s => mapping.excludedSubtaskTemplateIds.includes(s.taskTemplateId));
// Back to the registered time only: no distribution of the main task, no excluded subtasks.
export const resetTemplate = (mapping, template) => {
    const subtaskIds = template.subtasks.map(s => s.taskTemplateId);
    return Object.assign(Object.assign({}, setShares(mapping, template.taskTemplateId, [])), { excludedSubtaskTemplateIds: mapping.excludedSubtaskTemplateIds.filter(id => !subtaskIds.includes(id)) });
};
// Mapping rows without a template are still being edited, so they are left out of the preview.
export const toPreviewMapping = (mapping) => ({
    unproductiveResourceIds: mapping.unproductiveResourceIds,
    resourceMappings: mapping.resourceMappings
        .map(m => (Object.assign(Object.assign({}, m), { targets: m.targets.filter(t => !!t.taskTemplateId) })))
        .filter(m => m.targets.length > 0 || m.excludedTemplateIds.length > 0),
    distributions: mapping.distributions,
    excludedSubtaskTemplateIds: mapping.excludedSubtaskTemplateIds,
});
